import { useRef, useEffect } from "react";

export const useDragScroll = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  useEffect(() => {
    const handleMouseDown = (e: globalThis.MouseEvent) => {
      if (!containerRef.current) return;
      isDragging.current = true;
      startX.current = e.pageX - containerRef.current.offsetLeft;
      scrollLeft.current = containerRef.current.scrollLeft;

      e.preventDefault();
    };

    const handleMouseUp = () => {
      isDragging.current = false;

      if (containerRef.current) {
        const links = containerRef.current.getElementsByTagName("a");
        Array.from(links).forEach((link) => {
          link.style.pointerEvents = "auto";
        });
      }
    };

    const handleMouseMove = (e: globalThis.MouseEvent) => {
      if (!isDragging.current || !containerRef.current) return;
      e.preventDefault();
      const x = e.pageX - containerRef.current.offsetLeft;
      const scroll = x - startX.current;
      containerRef.current.scrollLeft = scrollLeft.current - scroll;

      const links = containerRef.current.getElementsByTagName("a");
      Array.from(links).forEach((link) => {
        link.style.pointerEvents = "none";
      });
    };

    const handleTouchStart = (e: globalThis.TouchEvent) => {
      if (!containerRef.current || !e.touches[0]) return;
      isDragging.current = true;
      startX.current = e.touches[0].pageX - containerRef.current.offsetLeft;
      scrollLeft.current = containerRef.current.scrollLeft;
    };

    const handleTouchMove = (e: globalThis.TouchEvent) => {
      if (!isDragging.current || !containerRef.current || !e.touches[0]) return;
      const x = e.touches[0].pageX - containerRef.current.offsetLeft;
      const scroll = x - startX.current;
      containerRef.current.scrollLeft = scrollLeft.current - scroll;
    };

    if (!containerRef.current) return;

    const container = containerRef.current;

    // Add event listeners without type assertions
    container.addEventListener("mousedown", handleMouseDown);
    container.addEventListener("mouseleave", handleMouseUp);
    container.addEventListener("mouseup", handleMouseUp);
    container.addEventListener("mousemove", handleMouseMove);
    container.addEventListener("touchstart", handleTouchStart);
    container.addEventListener("touchmove", handleTouchMove);
    container.addEventListener("touchend", handleMouseUp);

    return () => {
      // Remove event listeners
      container.removeEventListener("mousedown", handleMouseDown);
      container.removeEventListener("mouseleave", handleMouseUp);
      container.removeEventListener("mouseup", handleMouseUp);
      container.removeEventListener("mousemove", handleMouseMove);
      container.removeEventListener("touchstart", handleTouchStart);
      container.removeEventListener("touchmove", handleTouchMove);
      container.removeEventListener("touchend", handleMouseUp);
    };
  }, []);

  return containerRef;
};
